import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const advancedNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Advanced,
  icon: 'settings',
  route: `/${RoutesEnum.Advanced}`,
};
